import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const VisualizerDriftIntensitySlider = (props) => {
    const { intensity, customMode, updateVisualizerSettings } = props;

    const onIntensityChange = useCallback((value) => {
        if (value === intensity) return;
        updateVisualizerSettings({ drift: { intensity: value } });
    }, [intensity, updateVisualizerSettings]);

    return (
        <SliderListItem
            title='Intensity'
            displayMultiplier={1}
            value={intensity}
            min={0}
            max={100}
            step={1}
            onValueChange={onIntensityChange}
            disabled={customMode}
        />
    );
};

const mapStateToProps = (state) => {
    const { drift } = state.createPreview.present.videoSettings.visualizer;
    return {
        intensity: drift.intensity ?? 0,
        customMode: Boolean(drift.customMode)
    };
};

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerDriftIntensitySlider);
